import AxiosConfig from '../../../config/AxiosConfig';

const useAttachmentData = (_attachmentLink) => {
  const getAttachmentData = async (attachmentLink) => {
    try {
      const response = await AxiosConfig.create('put', '/attachments/')
        .call(attachmentLink)
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to put attachment data:', err);
      return null;
    }
  };

  return {
    getAttachmentData,
  };
};

export default useAttachmentData;
